import VideoMode from "src/constants/videoMode";
import { videoModeChanged } from "src/duck/actions";
import { store } from "src/store/store";

export default function createVideoModeUpdater(getStations, onStationUpdate) {
  let isEnabled = false;
  let unsubcribe = null;

  const getScreenAspectRatio = (jid) => {
    try {
      const video = document.querySelector(`.baby-video-${jid}`);
      const width = video.offsetWidth;
      const height = video.offsetHeight;
      return width / height;
    } catch (e) {
      return null;
    }
  };

  const getStreamAspectRatioForBaby = (jid) => {
    try {
      const video = document.querySelector(`.baby-video-${jid}`);
      const width = video.videoWidth;
      const height = video.videoHeight;
      return width / height;
    } catch (e) {
      return null;
    }
  };

  const onStoreUpdate = () => {
    const shouldAutoUpdate = store.getState().app.autoUpdateVideoMode;
    if (shouldAutoUpdate) {
      updateForAllStations();
      isEnabled = true;
    } else {
      isEnabled = false;
      onStationUpdate(null);
    }
  };

  const updateForStation = (station) => {
    if (!isEnabled) return;

    const currentVideoMode = store.getState().app.videoMode;

    const trackRatio = getStreamAspectRatioForBaby(station.jid);
    const currentRatio = getScreenAspectRatio(station.jid);

    if (!trackRatio || !currentRatio) return;

    if (
      (trackRatio > 1 && currentRatio > 1) ||
      (trackRatio < 1 && currentRatio < 1)
    ) {
      if (currentVideoMode !== VideoMode.COVER) {
        store.dispatch(videoModeChanged(VideoMode.COVER));
      }
      if (station.videoMode !== VideoMode.COVER) {
        onStationUpdate(station.jid, VideoMode.COVER);
      }
    } else {
      if (currentVideoMode !== VideoMode.CONTAIN) {
        store.dispatch(videoModeChanged(VideoMode.CONTAIN));
      }
      if (station.videoMode !== VideoMode.CONTAIN) {
        onStationUpdate(station.jid, VideoMode.CONTAIN);
      }
    }
  };

  const updateForAllStations = () => {
    (Object.values(getStations()) || []).forEach(updateForStation);
  };

  const init = () => {
    if (isEnabled) return;

    const shouldAutoUpdate = store.getState().app.autoUpdateVideoMode;
    if (shouldAutoUpdate) isEnabled = true;

    unsubcribe = store.subscribe(onStoreUpdate);
  };

  const destroy = () => {
    isEnabled = false;
    unsubcribe?.();
    onStationUpdate(null);
  };

  return { destroy, init, updateForStation };
}
